//apiService
import axios from 'axios';
import { API_URL } from "../utility/config";

const API_BASE_URL = API_URL

//POST 
export const postMethod = async (url, data) => {
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        const resText = await res.text();

        if (!res.ok) {
            console.error('Server responded with error:', resText);
            throw new Error(`HTTP ${res.status}: ${resText}`);
        }

        return JSON.parse(resText);
    } catch (err) {
        console.error('postMethod caught error:', err.message);
        throw err;
    }
};

//GET 
export const getMethod = async (endpoint) => {
    try {
        const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
            method: 'GET',
        });
        const text = await response.text();
        let result;

        try {
            result = JSON.parse(text);
        } catch {
            return {
                error: 'invalid JSON response1',
                status: response.status,
                raw: text,
            };
        }

        if (!response.ok) {
            console.error('API GET error:', result);
            return {
                error: result.error || result.message || `Error ${response.status}`,
                status: response.status,
            };
        }
        return result;

    } catch (error) {
        console.error('Network error:', error);
        return { error: 'Network error or server is unreachable.' };
    }
};


